import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiToggleButton = {
  defaultProps: {
    color: "primary"
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
      "&:hover, &:focus-visible": {
        backgroundColor: theme.palette.action.hover
      },
      ...!ownerState.size || ownerState.size === "medium" ? {
        height: `${capitalDesignTokens.componentSizes.medium}px`,
        minHeight: `${capitalDesignTokens.componentSizes.medium}px`,
        padding: "6px 12px",
        fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
        "& .MuiSvgIcon-root": {
          fontSize: "18px"
        }
      } : {}
    }),
    sizeSmall: {
      height: `${capitalDesignTokens.componentSizes.small}px`,
      minHeight: `${capitalDesignTokens.componentSizes.small}px`,
      padding: "4px 8px",
      fontSize: capitalDesignTokens.componentFontSizes.small,
      "& .MuiSvgIcon-root": {
        fontSize: "16px"
      }
    },
    sizeMedium: {
      height: `${capitalDesignTokens.componentSizes.medium}px`,
      minHeight: `${capitalDesignTokens.componentSizes.medium}px`,
      padding: "6px 12px",
      fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
      "& .MuiSvgIcon-root": {
        fontSize: "18px"
      }
    },
    sizeLarge: {
      height: `${capitalDesignTokens.componentSizes.large}px`,
      minHeight: `${capitalDesignTokens.componentSizes.large}px`,
      padding: "8px 16px",
      fontSize: capitalDesignTokens.componentFontSizes.large,
      "& .MuiSvgIcon-root": {
        fontSize: "20px"
      }
    }
  }
};
export {
  MuiToggleButton
};
//# sourceMappingURL=MuiToggleButton.js.map
